@if (item(); as item) {
  @if (item.description) {
    <nz-form-label>{{ item.description }}</nz-form-label>
  }
  <nz-form-control>
    <input
      nz-input
      [placeholder]="item.key || ''"
      [ngModel]="data()"
      (ngModelChange)="dataChange.emit($event)"
      [name]="item.key"
      [nzAutocomplete]="auto"
    />
    <nz-autocomplete
      [nzDataSource]="getAutocompleteOptions(item)"
      nzBackfill
      #auto
    />
  </nz-form-control>
}
